import type from './type';

export default class RangeValue {

    state = {}
    
    constructor(min = NaN, max = NaN, hasValues = false) {
        this.state.min = parseFloat(min);
        this.state.max = parseFloat(max);
        this.state.hasValues = hasValues;
    }

    isInRange = (value) => {
        if(!type.isNumber(value)) {
            console.error('value must be a number', value, typeof(value))
            return false;
        }

        value = parseFloat(value);

        const { min, max } = this.state;

        if(!isNaN(min) && !isNaN(max)) {
            return value >= min && value <= max;
        }
        else if(!isNaN(min)) {
            return value >= min
        }
        else if(!isNaN(max)) {
            return value <= max;
        }

        return false;
    }

    hasValues() {
        return this.state.hasValues;
    }
}